import {merge} from "./../common/utils.js";
import {Player} from "./../entities/player.js";

export class PositionManager {
	players = {};
	removalQueue = [];


	add(player) {
		console.log("PositionManager::add", player);
		this.players[player.uid] = player;
		return this.players[player.uid]
	}

	reset() {
		this.players = {};
		this.removalQueue = [];
	}

	addPlayer(uid, initialOffset = {x: 0, y: 48, z: 100}, deviceType, isLocal = false) {
		console.log("adding player: ", uid);
		// this.players[uid] = {
		// 	uid: uid,
		// 	local: isLocal,
		// 	device_type: deviceType,
		// 	position: {x: 0, y: 0, z: 0},
		// 	offset: initialOffset
		// };

		const player = new Player(uid, deviceType,isLocal);
		player.offset= initialOffset;

		this.players[uid] = player;

		return this.players[uid]
	}

	removePlayer(uid) {
		this.removalQueue.push(uid);
	}

	setInitialPosition(uid, position) {
		this.players[uid].position = position;
	}

	getInitialPosition(uid) {
		return this.players[uid].position;
	}

	setOffset(uid, data) {
		console.log("setOffset", uid, data);
		if (this.players[uid]) {
			this.players[uid].setOffset(data);
		} else {
			console.warn("[WARN] Adding player on move")
			this.addPlayer(uid, data.position, data.device_type);
		}
	}

	getOffset(uid) {
		return this.players[uid].getOffset();
	}

	getAbsolutePosition(player) {
		return merge(player.position, player.offset)
	}

	updatePosition(uid, data, speed = 0.06) {
		this.setOffset(uid, data);
		this.setDevicePosition(uid, speed);
	}


	setObserverPosition(uid) {
		var pos = this.players[uid].getAbsolutePosition()

		if (this.players[uid].cube) {
			this.players[uid].cube.quaternion.set(pos.x, pos.y, pos.z)
			this.players[uid].cube.position.set(pos.x, pos.y, pos.z)
		}

		if (this.players[uid].obj) {
			this.players[uid].obj.quaternion.set(pos.x, pos.y, pos.z)
			this.players[uid].obj.position.set(pos.x, pos.y, pos.z)
		}
		// players[p].cube.lookAt(new THREE.Vector3(0, 0, 0))
	}

	setDevicePosition(uid, speed = 0.06) {
		if (!this.players[uid].cube)
			return;

		const pos = this.players[uid].getAbsolutePosition()
		const cubePos = this.players[uid].cube.position

		let np = cubePos

		if (Math.abs(Math.abs(pos.x) - Math.abs(cubePos.x)) >= speed)
			np.x += (pos.x > cubePos.x ? speed : -speed); //move x
		if (Math.abs(Math.abs(pos.y) - Math.abs(cubePos.y)) >= speed)
			np.y += (pos.y > cubePos.y ? speed : -speed); //move y
		if (Math.abs(Math.abs(pos.z) - Math.abs(cubePos.z)) >= speed)
			np.z += (pos.z > cubePos.z ? speed : -speed); //move z

		// console.log("Updating devicePosition: ", np)
		this.players[uid].cube.position.set(np.x, np.y, np.z)
		// players[p].cube.position.set(pos.x, pos.y, pos.z)
	}
}